/* Fab Habitat — info, trade & legal pages
   Progressive enhancement only: every page is fully readable without this script. */
(function () {
  'use strict';

  var slug = function (text, used) {
    var base = (text || 'section')
      .toLowerCase()
      .replace(/section\s+\d+\s*[-–—]\s*/i, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'section';
    var id = base, n = 2;
    while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
    used[id] = true;
    return id;
  };

  var tidyLabel = function (text) {
    var t = text.replace(/\s+/g, ' ').trim().replace(/^section\s+\d+\s*[-–—]\s*/i, '');
    if (t === t.toUpperCase() && /[A-Z]/.test(t)) {
      t = t.toLowerCase().replace(/^./, function (c) { return c.toUpperCase(); });
    }
    return t;
  };

  /* ---------- Table of contents ---------- */
  function buildToc(aside, content) {
    var headings = content.querySelectorAll('h2');
    if (!aside || headings.length < 4) return;
    var list = aside.querySelector('.fh-toc__list');
    var used = {};
    var links = [];
    headings.forEach(function (h) {
      if (!h.id) h.id = slug(h.textContent, used);
      var li = document.createElement('li');
      // A button (not an in-page link): the site-wide ada-a11y-fixes.js treats consecutive
      // same-page #anchors as duplicate links and hides them from assistive technology.
      var a = document.createElement('button');
      var span = document.createElement('span');
      a.type = 'button';
      a.className = 'fh-toc__link';
      a.setAttribute('data-target', h.id);
      span.textContent = tidyLabel(h.textContent);
      a.appendChild(span);
      li.appendChild(a);
      list.appendChild(li);
      links.push({ a: a, h: h });
    });
    aside.hidden = false;

    var details = aside.querySelector('details');
    var mq = window.matchMedia('(min-width: 990px)');
    var sync = function () { if (details) details.open = mq.matches; };
    sync();
    if (mq.addEventListener) mq.addEventListener('change', sync);

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    list.addEventListener('click', function (e) {
      var a = e.target.closest('.fh-toc__link');
      if (!a) return;
      var target = document.getElementById(a.getAttribute('data-target'));
      if (!target) return;
      if (!mq.matches && details) details.open = false;
      // Scroll to the section and move focus to its heading so keyboard and screen reader users land there too.
      target.setAttribute('tabindex', '-1');
      target.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'start' });
      target.focus({ preventScroll: true });
      if (history.replaceState) history.replaceState(null, '', '#' + target.id);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          links.forEach(function (l) {
            var on = l.h === en.target;
            l.a.classList.toggle('is-current', on);
          });
        });
      }, { rootMargin: '-20% 0px -70% 0px' });
      links.forEach(function (l) { io.observe(l.h); });
    }
  }

  /* ---------- FAQ accordion (WAI-ARIA APG disclosure pattern) ---------- */
  function buildFaq(root) {
    var nodes = Array.prototype.slice.call(root.childNodes);
    if (!root.querySelector('h2')) return;
    var used = {};
    var items = [];
    var frag = document.createDocumentFragment();
    var item = null, panel = null;

    nodes.forEach(function (node) {
      if (node.nodeType === 1 && node.tagName === 'H2') {
        var text = node.textContent.replace(/\s+/g, ' ').trim();
        var id = slug(text, used);
        item = document.createElement('div');
        item.className = 'fh-faq__item';
        var h = document.createElement('h2');
        h.id = id;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'fh-faq__trigger';
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-controls', id + '-panel');
        var label = document.createElement('span');
        label.textContent = text;
        var icon = document.createElement('span');
        icon.className = 'fh-faq__icon';
        icon.setAttribute('aria-hidden', 'true');
        btn.appendChild(label);
        btn.appendChild(icon);
        h.appendChild(btn);
        panel = document.createElement('div');
        panel.className = 'fh-faq__panel';
        panel.id = id + '-panel';
        panel.hidden = true;
        item.appendChild(h);
        item.appendChild(panel);
        frag.appendChild(item);
        items.push({ btn: btn, panel: panel, id: id });
      } else if (panel) {
        panel.appendChild(node);
      } else {
        frag.appendChild(node); // any intro content before the first question
      }
    });

    if (!items.length) return;

    var set = function (it, open) {
      it.btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      it.panel.hidden = !open;
    };

    var tools = document.createElement('div');
    tools.className = 'fh-faq__tools';
    var all = document.createElement('button');
    all.type = 'button';
    all.className = 'fh-faq__toggle-all';
    all.textContent = 'Expand all';
    tools.appendChild(all);

    root.innerHTML = '';
    root.appendChild(tools);
    root.appendChild(frag);

    var syncAll = function () {
      var anyClosed = items.some(function (it) { return it.panel.hidden; });
      all.textContent = anyClosed ? 'Expand all' : 'Collapse all';
    };

    items.forEach(function (it) {
      it.btn.addEventListener('click', function () {
        set(it, it.panel.hidden);
        syncAll();
      });
    });
    all.addEventListener('click', function () {
      var open = items.some(function (it) { return it.panel.hidden; });
      items.forEach(function (it) { set(it, open); });
      syncAll();
    });

    // Open the question named in the URL (#where-do-you-ship-from), otherwise the first one.
    var hash = decodeURIComponent((location.hash || '').slice(1));
    var target = items.filter(function (it) { return it.id === hash; })[0] || items[0];
    set(target, true);
    syncAll();
  }

  /* Help strip + cross-links, mirroring snippets/fh-help-strip.liquid and snippets/fh-policy-nav.liquid */
  var POLICY_LINKS = [
    ['/pages/frequently-asked-questions', 'FAQs'],
    ['/pages/policies', 'Returns & exchanges'],
    ['/pages/warranty', 'Warranty'],
    ['/policies/privacy-policy', 'Privacy policy'],
    ['/pages/data-sharing-opt-out', 'Your privacy choices'],
    ['/pages/terms', 'Terms & conditions'],
    ['/pages/accessibility', 'Accessibility']
  ];

  function appendPolicyExtras(container) {
    if (document.querySelector('.fh-info--policy')) return;
    var wrap = document.createElement('div');
    wrap.className = 'fh-info fh-info--policy';
    var links = POLICY_LINKS.map(function (l) {
      var cur = location.pathname === l[0] ? ' aria-current="page"' : '';
      return '<li><a href="' + l[0] + '"' + cur + '>' + l[1].replace('&', '&amp;') + '</a></li>';
    }).join('');
    wrap.innerHTML =
      '<div class="fh-info__body fh-info__body--after">' +
        '<section class="fh-help" aria-labelledby="fh-help-title">' +
          '<div class="fh-help__text">' +
            '<p class="fh-eyebrow">Need a hand?</p>' +
            '<h2 class="fh-help__title" id="fh-help-title">We’re here for you.</h2>' +
            '<p>Questions about an order, a product or this page? Our team is happy to help.</p>' +
          '</div>' +
          '<ul class="fh-help__actions" role="list">' +
            '<li><a class="fh-button fh-button--filled" href="/pages/contact">Contact us</a></li>' +
            '<li><a class="fh-button fh-button--outline" href="mailto:sales@fabhabitat.com">Email us<span class="visually-hidden"> at sales@fabhabitat.com</span></a></li>' +
            '<li><a class="fh-link-underline" href="tel:+17324010634">Call +1 (732) 401-0634</a></li>' +
          '</ul>' +
        '</section>' +
        '<nav class="fh-policy-nav" aria-label="Customer care and policies">' +
          '<p class="fh-eyebrow" aria-hidden="true">Customer care &amp; policies</p>' +
          '<ul role="list">' + links + '</ul>' +
        '</nav>' +
      '</div>';
    container.parentNode.insertBefore(wrap, container.nextSibling);
  }

  /* ---------- Shopify policy pages (/policies/*) ---------- */
  function enhancePolicy() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container) return;
    appendPolicyExtras(container);
    var body = container.querySelector('.shopify-policy__body');
    var rte = body && body.querySelector('.rte');
    if (!rte || rte.querySelectorAll('h2').length < 6) return;
    container.classList.add('fh-policy--toc');
    var layout = document.createElement('div');
    layout.className = 'fh-policy-layout';
    var aside = document.createElement('div');
    aside.className = 'fh-toc';
    aside.hidden = true;
    aside.innerHTML =
      '<details class="fh-toc__details" open>' +
      '<summary class="fh-toc__summary"><span class="fh-eyebrow">On this page</span></summary>' +
      '<nav aria-label="On this page"><ol class="fh-toc__list" role="list"></ol></nav></details>';
    rte.parentNode.insertBefore(layout, rte);
    layout.appendChild(aside);
    layout.appendChild(rte);
    buildToc(aside, rte);
  }

  function init() {
    document.querySelectorAll('.fh-info__layout--toc').forEach(function (layout) {
      buildToc(layout.querySelector('[data-fh-toc]'), layout.querySelector('.fh-info__content'));
    });
    document.querySelectorAll('[data-fh-faq]').forEach(buildFaq);
    enhancePolicy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
